module.exports = __webpack_public_path__ + "media/images/undraw_posting_photo-96a2c3f036f07f962f82d4d9e4b72ae0.svg";